export const resetTime = 0.5
// export const hostPort = 'epod-api.mobileways.tk'
// export const hostPort = '183.82.120.223:8596'
export const hostPort = 'api.epodtech.com' // this domain is configured in freenom for one year; corresponding ip address is 3.8.43.14
export const protocol = 'https'

export const apiBaseUrl = `${protocol}://${hostPort}/api`
// export const socketHostPort = `wss://sm958l350000.test.connect.paymentsense.cloud/pac?token=93082359-eede-41fa-9486-c587c72634c6&api-version=v0`
export const socketHostPort = `wss://${localStorage.getItem('wss-sockethost') || 'pu749m120000.connect.paymentsense.cloud'}/pac?token=${localStorage.getItem('wss-token') || 'f3924eb0-14a8-4fea-a45b-8a3b8f8ab74e'}&api-version=v0`



// WEBPACK FOOTER //
// ./src/api/constants.js